<template>
  <div>
    <span v-if="iconRight">{{ division_obj.division }}</span>
    <v-icon
      v-text='division_obj.icon'
      :color='division_obj.icon_color'
      :small='!small'
      :x-small='small'
      :left='!iconRight'
      :right='iconRight'
    ></v-icon>
    <span v-if="!iconRight">{{ division_obj.division }}</span>
  </div>
</template>

<script>
export default {
  name: 'wc-division-nai',
  props: {
    division_obj: {
      required: true
    },
    small: {
      required: false,
      type: Boolean,
      default: false
    },
    iconRight: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
